import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from '../bo/configurationSaisieDonneesAnalyse';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DonneeAnalyse, MultiKpi } from '../bo/donneeAnalyse';
import { TraductionService } from './traduction.service';
import { ReferentielDonneeAnalyse } from '../bo/referentielDonneeAnalyse';
import { UnitDefinitionDto } from '../bo/unitDefinition';


@Injectable({
  providedIn: 'root'
})
export class KpiService {
    tabModeSaisieProjet: any[] = [];


  constructor(
    private readonly HttpService: HttpService,
    private readonly traductionService: TraductionService,
  ) { }

  updateKpiConfiguration(configDto: ConfigurationSaisieDonneesAnalyse[]): Observable<any> {
    return this.HttpService.put('ConfigAnalysisEntry', configDto);
  }

  updateDonneeAnalyse(donneeAnalyse: DonneeAnalyse): Observable<any> {
    return this.HttpService.post<DonneeAnalyse, any>('AnalysisData', donneeAnalyse);
  }

  AddDonneeAnalyse(multiKpi: MultiKpi): Observable<any> {
    return this.HttpService.post<MultiKpi, any>(`AnalysisData/List`, multiKpi);
  }

  getUnits(quantityType: string): Observable<UnitDefinitionDto[]> {
    return this.HttpService.get<UnitDefinitionDto[]>('AnalysisData/units', { quantityType });
  }
  
  getCalculModeSaisieProjet(): Observable<any> {
    return this.traductionService.translate.get(
      [
        'GLOBAL.MOYENNE',
        'GLOBAL.SOMME',
        'GLOBAL.MINIMUM',
        'GLOBAL.MAXIMUM',
        'GLOBAL.MANUELLE',
        'GLOBAL.MEDIAN',
        'GLOBAL.PRODUCT',
        'GLOBAL.PERCENT',
        'GLOBAL.GRAPHE'
      ]
    ).pipe(
      map(traduction => {
        this.tabModeSaisieProjet = [
          { nom: traduction['GLOBAL.MANUELLE'], val: ModeSaisie.Manuelle },
          { nom: traduction['GLOBAL.SOMME'], val: ModeSaisie.Somme },
          { nom: traduction['GLOBAL.MOYENNE'], val: ModeSaisie.Moyenne },
          { nom: traduction['GLOBAL.MINIMUM'], val: ModeSaisie.Min },
          { nom: traduction['GLOBAL.MAXIMUM'], val: ModeSaisie.Max },
          { nom: traduction['GLOBAL.MEDIAN'], val: ModeSaisie.Median },
          { nom: traduction['GLOBAL.PRODUCT'], val: ModeSaisie.Product },
          { nom: traduction['GLOBAL.PERCENT'], val: ModeSaisie.Percent },
          { nom: traduction['GLOBAL.GRAPHE'], val: ModeSaisie.Graphe }
        ];
        return this.tabModeSaisieProjet;
      })
    );
  }

    getSiteConfigAnalysisEntry(siteId: number): Observable<ConfigurationSaisieDonneesAnalyse[]> {
      return this.HttpService.get<ConfigurationSaisieDonneesAnalyse[]>(`Sites/${siteId}/ConfigAnalysisEntry`)
        .pipe(
          map(configs => {
            configs.forEach((conf: ConfigurationSaisieDonneesAnalyse) => {
              this.setTypeSaisieKpi(conf.referentielDonneeAnalyse);
              this.traductionService.translate.get([
                conf.referentielDonneeAnalyse.nom,
                conf.referentielDonneeAnalyse.type
              ]).subscribe(translations => {
                conf.referentielDonneeAnalyse.nom = translations[conf.referentielDonneeAnalyse.nom];
                conf.referentielDonneeAnalyse.type = translations[conf.referentielDonneeAnalyse.type];
              });
            });
            return configs;
          })
        );
    }

      getBlastAnalysisData(tirId: number): Observable<DonneeAnalyse[]> {
        return this.HttpService.get<DonneeAnalyse[]>(`Blasts/${tirId}/AnalysisData`)
          .pipe(
            map(donnees => {
              donnees.forEach((donnee: DonneeAnalyse) => {
                if (donnee.referentielDonneeAnalyse.nom == 'KPI.PLAINTE' || donnee.referentielDonneeAnalyse.nom == 'KPI.SAFETY_PROB'
                  || donnee.referentielDonneeAnalyse.nom == 'KPI.DRILL_PATTERN'
                ) {
                  donnee.referentielDonneeAnalyse.typeSaisieKpi = 'YesOrNo';
                } else {
                  donnee.referentielDonneeAnalyse.typeSaisieKpi = 'InputText';
                }
                this.traductionService.translate.get([
                  donnee.referentielDonneeAnalyse.nom,
                  donnee.referentielDonneeAnalyse.type,
                ]).subscribe(translations => {
                  donnee.referentielDonneeAnalyse.nom = translations[donnee.referentielDonneeAnalyse.nom];
                  donnee.referentielDonneeAnalyse.type = translations[donnee.referentielDonneeAnalyse.type];
                });
              });
              return donnees;
            })
          );
  }

  getProjectAnalysisData(projetId: number): Observable<DonneeAnalyse[]> {
    return this.HttpService.get<DonneeAnalyse[]>(`Projects/${projetId}/AnalysisData`)
      .pipe(
        map(donnees => {
          donnees.forEach((donnee: DonneeAnalyse) => {
            if (donnee.referentielDonneeAnalyse.nom == 'KPI.PLAINTE' || donnee.referentielDonneeAnalyse.nom == 'KPI.SAFETY_PROB') {
              donnee.referentielDonneeAnalyse.typeSaisieKpi = 'YesOrNo';
            } else {
              donnee.referentielDonneeAnalyse.typeSaisieKpi = 'InputText';
            }
            this.traductionService.translate.get([
              donnee.referentielDonneeAnalyse.nom,
              donnee.referentielDonneeAnalyse.type
            ]).subscribe(translations => {
              donnee.referentielDonneeAnalyse.nom = translations[donnee.referentielDonneeAnalyse.nom];
              donnee.referentielDonneeAnalyse.type = translations[donnee.referentielDonneeAnalyse.type];
            });
          });
          return donnees;
        })
      );
  }

  getBlaststAnalysisData(blastsId: string): Observable<DonneeAnalyse[]> {
    return this.HttpService.get<DonneeAnalyse[]>('Blasts/AnalysisData', { blastsId: blastsId })
      .pipe(
        map(donnees => {
          donnees.forEach((donnee: DonneeAnalyse) => {
            if (donnee.referentielDonneeAnalyse.nom == 'KPI.PLAINTE' || donnee.referentielDonneeAnalyse.nom == 'KPI.SAFETY_PROB') {
              donnee.referentielDonneeAnalyse.typeSaisieKpi = 'YesOrNo';
            } else {
              donnee.referentielDonneeAnalyse.typeSaisieKpi = 'InputText';
            }
            this.traductionService.translate.get([
              donnee.referentielDonneeAnalyse.nom,
              donnee.referentielDonneeAnalyse.type
            ]).subscribe(translations => {
              donnee.referentielDonneeAnalyse.nom = translations[donnee.referentielDonneeAnalyse.nom];
              donnee.referentielDonneeAnalyse.type = translations[donnee.referentielDonneeAnalyse.type];
            });
          });
          return donnees;
        })
      );
  }

  getSiteActiveAnalysisEntry(siteId: number): Observable<ReferentielDonneeAnalyse[]> {
    return this.HttpService.get<ReferentielDonneeAnalyse[]>(`Sites/${siteId}/ActiveAnalysisEntry`)
      .pipe(
        map(kpis => {
          kpis.forEach((kpi: ReferentielDonneeAnalyse) => {
            this.setTypeSaisieKpi(kpi);
            this.traductionService.translate.get([
              kpi.nom,
              kpi.type
            ]).subscribe(translations => {
              kpi.nom = translations[kpi.nom];
              kpi.type = translations[kpi.type];
            });
          });
          return kpis.sort((a, b) => a.nom.localeCompare(b.nom));
        })
      );
  }
  
    private setTypeSaisieKpi(kpi: ReferentielDonneeAnalyse): void {
      if (kpi.nom == 'KPI.PLAINTE' || kpi.nom == 'KPI.SAFETY_PROB') {
        kpi.typeSaisieKpi = 'YesOrNo';
      } else {
        kpi.typeSaisieKpi = 'InputText';
      }
    }

  triggerKpiCalculation(tirId: number): Observable<any> {
    return this.HttpService.post(`Blasts/${tirId}/trigger-kpis`, {});
  }
    
  }





